import { create, createOptions, DocumentFormat, RichEditUnit, ViewType } from "devexpress-richedit";
import { useEffect, useRef } from "react";
import "./RichEditComponent.css";

const RichEditComponent = ({
  documentAsBase64,
  editToggle,
  reportname,
  setdocumentAsBase64,
  clone,
  updatedocumentAsBase64,
}) => {
  const richRef = useRef(null);
  const containerRef = useRef(null);
  const saveTimeout = useRef(null);

  const internalUpdateRef = useRef(false);
  const lastOpenedDocumentRef = useRef(null);

  useEffect(() => {
    if (richRef.current) {
      richRef.current.readOnly = !editToggle;
    }
  }, [editToggle]);

  useEffect(() => {
    if (richRef.current || !containerRef.current) return;

    const options = createOptions();

    options.bookmarks.visibility = true;
    options.bookmarks.color = "#ff0000";
    options.confirmOnLosingChanges.enabled = false;

    options.fields.updateFieldsBeforePrint = true;
    options.fields.updateFieldsOnPaste = true;

    options.mailMerge.activeRecord = 2;
    options.mailMerge.viewMergedData = true;
    options.mailMerge.dataSource = [
      { Name: "Indy", age: 32 },
      { Name: "Andy", age: 28 },
    ];

    options.events.documentChanged = () => {
      if (!richRef.current) return;

      if (saveTimeout.current) {
        clearTimeout(saveTimeout.current);
      }

      saveTimeout.current = setTimeout(() => {
        const content = richRef.current.saveDocument(DocumentFormat.Rtf);

        if (content && typeof content.then === "function") {
          content
            .then((result) => {
              if (!result) return;
              internalUpdateRef.current = true;
              setdocumentAsBase64(result);
            })
            .catch((error) => {
              console.log("Error saving document:", error);
            });
        }
      }, 800);
    };

    options.events.lostFocus = () => {
      if (!richRef.current) return;

      const content = richRef.current.saveDocument(DocumentFormat.Rtf);

      if (content && typeof content.then === "function") {
        content.then((result) => {
          if (result) {
            internalUpdateRef.current = true;
            setdocumentAsBase64(result);
          }
        });
      }
    };

    options.events.saving = (s, e) => {
      if (e?.base64) {
        internalUpdateRef.current = true;
        setdocumentAsBase64(e.base64);
      }
    };

    options.unit = RichEditUnit.Inch;
    options.view.viewType = ViewType.PrintLayout;
    options.view.simpleViewSettings.paddings = {
      left: 15,
      top: 15,
      right: 15,
      bottom: 15,
    };

    options.readOnly = !editToggle;
    options.width = "100%";
    options.height = "900px";

    richRef.current = create(containerRef.current, options);

    if (documentAsBase64) {
      richRef.current.openDocument(documentAsBase64, reportname || "Document", DocumentFormat.Rtf);
      lastOpenedDocumentRef.current = documentAsBase64;
    }

    return () => {
      if (saveTimeout.current) {
        clearTimeout(saveTimeout.current);
      }

      if (richRef.current) {
        richRef.current.dispose();
        richRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!richRef.current || !documentAsBase64) return;

    if (internalUpdateRef.current) {
      internalUpdateRef.current = false;
      return;
    }

    if (lastOpenedDocumentRef.current === documentAsBase64) return;

    richRef.current.openDocument(documentAsBase64, reportname || "Document", DocumentFormat.Rtf);
    lastOpenedDocumentRef.current = documentAsBase64;
  }, [documentAsBase64, reportname]);

  useEffect(() => {
    updatedocumentAsBase64(documentAsBase64);
  }, [clone, editToggle]);

  return (
    <div className={`rich-wrapper ${!editToggle ? "readonly" : ""}`}>
      <div id="richEdit" ref={containerRef}></div>
    </div>
  );
};

export default RichEditComponent;